export default (contentPackageList: string): string => `
-- Here are the content packages the user has created so far and that is currently showing in the dashboard --
    
${contentPackageList}

If the user asks anything about any of these content packages, answer to the best of your ability.  If you're unable to derive the answer from this list, prompt the user to open the content package, and then ask the question again.  Render your response using markdown.

If you render the name of any content package, use the content package's name as a link to the content package.  For example, if the content package's name is "My First Content Package" with an id of "123", you should render it as [My First Content Package](/content/123).
`;
